__turbopack_context__.v({
  "enter": "styles-module-scss-module__XdFC_q__enter",
  "exit": "styles-module-scss-module__XdFC_q__exit",
  "fade-in": "styles-module-scss-module__XdFC_q__fade-in",
  "fade-out": "styles-module-scss-module__XdFC_q__fade-out",
  "fade-out-80": "styles-module-scss-module__XdFC_q__fade-out-80",
  "skeletonCanvas": "styles-module-scss-module__XdFC_q__skeletonCanvas",
  "skeletonLabel": "styles-module-scss-module__XdFC_q__skeletonLabel",
  "skeletonOverlay": "styles-module-scss-module__XdFC_q__skeletonOverlay",
  "skeletonRoot": "styles-module-scss-module__XdFC_q__skeletonRoot",
  "slide-in-from-bottom": "styles-module-scss-module__XdFC_q__slide-in-from-bottom",
  "slide-in-from-left": "styles-module-scss-module__XdFC_q__slide-in-from-left",
  "slide-in-from-right": "styles-module-scss-module__XdFC_q__slide-in-from-right",
  "slide-in-from-top": "styles-module-scss-module__XdFC_q__slide-in-from-top",
  "slide-out-to-bottom": "styles-module-scss-module__XdFC_q__slide-out-to-bottom",
  "slide-out-to-left": "styles-module-scss-module__XdFC_q__slide-out-to-left",
  "slide-out-to-right": "styles-module-scss-module__XdFC_q__slide-out-to-right",
  "slide-out-to-top": "styles-module-scss-module__XdFC_q__slide-out-to-top",
  "zoom-in": "styles-module-scss-module__XdFC_q__zoom-in",
  "zoom-out": "styles-module-scss-module__XdFC_q__zoom-out",
});
